// extracted by mini-css-extract-plugin
export var btn = "dialogNewsletter-module--btn--jjOur";
export var cont = "dialogNewsletter-module--cont--lAD8j";
export var dialogcontent = "dialogNewsletter-module--dialogcontent--YhNvK";
export var headline = "dialogNewsletter-module--headline--B+qSw";
export var root = "dialogNewsletter-module--root---CkqH";